// Brand logo slider

$("#brand_logo_slider").owlCarousel({
  loop: false,
  margin: 20,
  nav: false,
  responsive: {
    0: {
      items: 2,
    },
    600: {
      items: 3,
    },
    1000: {
      items: 3,
    },
  },
});

$(".popup-gallery").magnificPopup({
  delegate: ".owl-item:not(.cloned) a",
  type: "image",
  removalDelay: 500,
  callbacks: {
    beforeOpen: function () {
      this.st.image.markup = this.st.image.markup.replace(
        "mfp-figure",
        "mfp-figure mfp-with-anim"
      );
      this.st.mainClass = this.st.el.attr("data-effect");
    },
  },
  tLoading: "Loading image #%curr%...",
  mainClass: "mfp-img-mobile",
  gallery: {
    enabled: true,
    navigateByImgClick: true,
    preload: [0, 1],
  },
  image: {
    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
    titleSrc: function (item) {
      return item.el.attr("title") + "<small></small>";
    },
  },
});

// Product Tabs

$(".tab-nav li a").on("click", function () {
  var target = $(this).attr("data-rel");
  $(".tab-nav li a").removeClass("active");
  $(this).addClass("active");
  $("#" + target)
    .show()
    .siblings(".tab-box")
    .hide();
  return false;
});

// Product reviews go to Tab

$(".all-reviews-text").on("click", function () {
  var target = "tab-recensioni";
  $(".tab-nav li a").removeClass("active");
  $("[data-rel|='tab-recensioni']").addClass("active");
  $("#" + target)
    .show()
    .siblings(".tab-box")
    .hide();
  $("html, body").animate(
    {
      scrollTop: $("[data-rel|='tab-recensioni']").offset().top,
    },
    1000
  );
  return false;
});

// Filter Modal

const modalTriggerButtons = document.querySelectorAll("[data-modal-target]");
const btnicon = document.querySelectorAll(".icon-svg-24");
const modals = document.querySelectorAll(".modal-head");
const modalCloseButtons = document.querySelectorAll(".modal-close");

modalTriggerButtons.forEach((elem) => {
  elem.addEventListener("click", (event) =>
    toggleModal(event.currentTarget.getAttribute("data-modal-target"))
  );
});
modalCloseButtons.forEach((elem) => {
  elem.addEventListener("click", (event) =>
    toggleModal(event.currentTarget.closest(".modal-head").id)
  );
});
modals.forEach((elem) => {
  elem.addEventListener("click", (event) => {
    if (event.currentTarget === event.target)
      toggleModal(event.currentTarget.id);
  });
});

// Close Modal with "Esc"...
document.addEventListener("keydown", (event) => {
  if (
    event.keyCode === 27 &&
    document.querySelector(".modal-head.modal-show")
  ) {
    toggleModal(document.querySelector(".modal-head.modal-show").id);
  }
});

function toggleModal(modalId) {
  const modal = document.getElementById(modalId);

  if (getComputedStyle(modal).display === "flex") {
    // alternatively: if(modal.classList.contains("modal-show"))
    modal.classList.add("modal-hide");
    setTimeout(() => {
      $("#iconsvg ").removeClass("svg-icon2");
      $("#iconsvg1").removeClass("svg-icon2");
      document.body.style.overflow = "initial";
      $("body").removeClass("tz-model-open");
      modal.classList.remove("modal-show", "modal-hide");
      modal.style.display = "none";
    }, 200);
  } else {
    $("#iconsvg").toggleClass("svg-icon2");
    $("#iconsvg1").toggleClass("svg-icon2");
    document.body.style.overflow = "hidden";
    $("body").addClass("tz-model-open");
    modal.style.display = "flex";
    modal.classList.add("modal-show");
  }
}

// Filter Buttons

function toggleView(view) {
  if (view === "list") {
    $(".list-view-button").addClass("tz-active");
    $(".grid-view-button").removeClass("tz-active");
    $(".tz-collection-product-list").show();
    $(".tz-collection-product-grid").hide();
    localStorage.setItem("viewMode", "list");
  } else {
    $(".grid-view-button").addClass("tz-active");
    $(".list-view-button").removeClass("tz-active");
    $(".tz-collection-product-grid").show();
    $(".tz-collection-product-list").hide();
    localStorage.setItem("viewMode", "grid");
  }
}

const savedView = localStorage.getItem("viewMode") || "grid";

toggleView(savedView);


$(document).ready(function () {

  $(".list-menu__item.facets__item").click(function () {
    // location.reload();
  }); 
  
  if (savedView === "list") {
    toggleView("list");
  } else {
    toggleView("grid");
  }

  $(".list-view-button").click(function () {
    toggleView("list");
  });

  $(".grid-view-button").click(function () {
    toggleView("grid");
  });

  

  // Product Instruction Tab

  function getURLParameterValue(param) {
    var url = new URL(window.location.href);
    var params = new URLSearchParams(url.search);
    return params.get(param);
  }

  var tabValue = getURLParameterValue("tab");

  if (sessionStorage.getItem("scrollPosition")) {
    $("html, body").scrollTop(sessionStorage.getItem("scrollPosition"));
    sessionStorage.removeItem("scrollPosition");
  }

  if (tabValue == "istruzioni") {
    var target = "tab-istruzioni";

    sessionStorage.setItem("scrollPosition", $(window).scrollTop());

    $(".tab-nav li a").removeClass("active");
    $("[data-rel|='tab-istruzioni']").addClass("active");

    $("#" + target)
      .show()
      .siblings(".tab-box")
      .hide();

    $("html, body").animate(
      {
        scrollTop: $("[data-rel|='tab-istruzioni']").offset().top,
      },
      1000
    );
  }

  if (tabValue == "recensioni") {
    var target = "tab-recensioni";

    sessionStorage.setItem("scrollPosition", $(window).scrollTop());

    $(".tab-nav li a").removeClass("active");
    $("[data-rel|='tab-recensioni']").addClass("active");

    $("#" + target)
      .show()
      .siblings(".tab-box")
      .hide();

    $("html, body").animate(
      {
        scrollTop: $("[data-rel|='tab-recensioni']").offset().top,
      },
      1000
    );
  }

  // Clear Filter on Wholesale Btn

  $(".tz-wholesale-btn,.collection .underlined-link").on("click", function () {
    easysearch.clearTagFilter();
  });

  // B2B VAT Included Price Product Page

  var customizedPrice = "";
  var priceWithVAT = 0;
  var interval;

  function calculatePriceWithVAT(priceString) {
    var priceWithoutSymbol = priceString.replace("€", "").trim();
    var price = parseFloat(priceWithoutSymbol.replace(",", "."));
    var priceIncludingVAT = price * 1.22;
    var priceWithComma = priceIncludingVAT.toFixed(2).replace(".", ",");
    return priceWithComma;
  }

  // function customPrice() {
  //   customizedPrice = $(".template-product .samitaWS-customized-price").text();

  //   if (customizedPrice !== "" && customizedPrice !== null) {
  //     clearInterval(interval);
  //     priceWithVAT = calculatePriceWithVAT(customizedPrice);
  //     $(".product__info-wrapper .tz-b2b-strike-price").css({
  //       "font-size": "40px",
  //       "text-decoration": "line-through",
  //       "line-height": "20px",
  //     });
  //     $(".tz-b2b-updated-price").text(`€${priceWithVAT}`);
  //   }
  // }

  // interval = setInterval(customPrice, 1000);

  // $('.select__select').change(function() {
  //   clearInterval(interval);
  //   interval = setInterval(customPrice, 1000);
  // });

  // Collection Page Price

  // $('.grid__item, .category-product-block .item-box, .tz-product-link').each(function() {
  //     var $this = $(this);
  //     var intervalId = setInterval(function() {
          
  //         var priceText = $this.find(".samitaWS-customized-price").text();      
          
  //         if (priceText !== "" && priceText !== null ) {
  //             clearInterval(intervalId);
  //             var priceWithVAT = calculatePriceWithVAT(priceText);
  //             $this.find(".tz-b2b-strike-price").css({
  //               "text-decoration": "line-through"
  //             });
  //             $this.find(".tz-b2b-updated-price").text(`€${priceWithVAT}`);
  //         }
  //     }, 1000);
  // });

  // Product Discount Calculation

  // let originalPrice = $('.product__info-wrapper .tz-vat-sale-price').text();
  // let discountPrice = $('.product__info-wrapper .tz-b2b-updated-price').text();

  // console.table(originalPrice,discountPrice);

  // if (originalPrice !== "" && originalPrice !== null && discountPrice !== "" && originalPrice !== null  ){
  //   let formattedOriginalPrice  = originalPrice.replace('€', '').replace(',', '.');
  //   let formattedDiscountPrice  = discountPrice.replace('€', '').replace(',', '.');
  //   let discountPercentage = ((formattedOriginalPrice - formattedDiscountPrice) / formattedOriginalPrice) * 100;
  //   discountPercentage = Math.round(discountPercentage);
  //   if(discountPercentage > 0){
  //     $('.tz-discount-wrapper').show();
  //     $('.tz-discount-percentage').text(`${discountPercentage}%`);
  //   }
  // }

  // B2B Product Discount Calculation 

  // const b2bInterval = setInterval(function() {
    // let b2bOriginalPrice = $('.product__info-wrapper .samitaWS-customized-original-price').text();
    // let b2bDiscountPrice = $('.product__info-wrapper .samitaWS-customized-price').text();
 
    // console.table(b2bOriginalPrice, b2bDiscountPrice);

    // if (b2bOriginalPrice.trim() !== "" && b2bDiscountPrice.trim() !== "") {
    //     let formattedb2bOriginalPrice  = b2bOriginalPrice.replace('€', '').replace(',', '.');
    //     let formattedb2bDiscountPrice  = b2bDiscountPrice.replace('€', '').replace(',', '.');
    //     let discountPercentage = ((formattedb2bOriginalPrice - formattedb2bDiscountPrice) / formattedb2bOriginalPrice) * 100;
    //     discountPercentage = Math.round(discountPercentage);
        // console.table(formattedb2bOriginalPrice,formattedb2bDiscountPrice);
        // if(discountPercentage > 0){
        //   $('.tz-discount-wrapper').show();
        //   $('.tz-discount-percentage').text(`${discountPercentage}%`);
        // }
        // clearInterval(b2bInterval);
      // }
    // }, 2000);

  // Add No Translate Class

  const flagIntervalId = setInterval(function() {
  let classAdded = false; 

    $('.tz-easy-form-wrapper #easysearch_field_20112 option,.modal-content-head .tz-easy-form-wrapper #easysearch_field_20112 option').each(function() {
        
        if ($(this).val().trim() !== "" && !$(this).hasClass('notranslate')) {
            $(this).addClass('notranslate');
            classAdded = true;
        }
    });

    if (classAdded) {
        clearInterval(flagIntervalId);
    }
   }, 100);

  const flagIntervalId_2 = setInterval(function() {
  let classAdded = false; 

    $('.tz-easy-form-wrapper #easysearch_field_20111 option,.modal-content-head .tz-easy-form-wrapper #easysearch_field_20111 option').each(function() {
        
        if ($(this).val().trim() !== "" && !$(this).hasClass('notranslate')) {
            $(this).addClass('notranslate');
            classAdded = true;
        }
    });

    if (classAdded) {
        clearInterval(flagIntervalId_2);
    }
   }, 100);

  // B2B VAT Prices BSS B2B Solution //

  // Product Page Prices

  let bssInterval; 
  
  function upadteVATPrices() {
      let bssComparePrice = $('.product__info-wrapper .bss-b2b-customized-compare-at-price').text();
      let bssOriginalPrice = $('.product__info-wrapper .price__container').text();
    
        if (bssComparePrice && bssOriginalPrice) {
          let formattedComparePrice  = bssComparePrice.replace('€', '').replace(',', '.');
          let formattedOriginalPrice  = bssOriginalPrice.replace('€', '').replace(',', '.');
          let vatComparePrice = calculatePriceWithVAT(bssComparePrice);
          let vatOriginalPrice = calculatePriceWithVAT(bssOriginalPrice);
          let discountPercentage = ((formattedComparePrice - formattedOriginalPrice) / formattedComparePrice) * 100;
          discountPercentage = Math.round(discountPercentage);
          if(discountPercentage > 0){
            $('.tz-discount-wrapper').show();
            $('.tz-discount-percentage').text(`${discountPercentage}%`);
          }
          if(vatComparePrice && vatOriginalPrice){
            $('.product__info-wrapper .tz-bss-b2b-vat-price').show();
            $('.product__info-wrapper .tz-bss-incl-vat-compare-price').text(`€${vatComparePrice}`);
            $('.product__info-wrapper .tz-bss-incl-vat-original-price').text(`€${vatOriginalPrice}`);
          }
          $('.product__info-wrapper .price__container').after('<span class="tz-excl-vat-text notranslate" style="margin: 0 0 0 1rem;">(excl. VAT)</span>');
          // console.table(bssComparePrice,bssOriginalPrice,formattedComparePrice,formattedOriginalPrice,vatComparePrice,vatOriginalPrice,discountPercentage);
          clearInterval(bssInterval);
        }
  }

  bssInterval = setInterval(upadteVATPrices, 1000);

  $('.select__select').change(function() {
    clearInterval(bssInterval);
    bssInterval = setInterval(upadteVATPrices, 1000);
  });

  // Collection Page Product Prices

  $('#product-grid .grid__item,.tz-product-link,.category-product-block .item-box,.product-grid .grid__item').each(function() {
    let $this = $(this);
    let loopIntervalId = setInterval(function() {
        
        let bssComparePrice = $this.find('.bss-b2b-customized-compare-at-price').text();
        let bssOriginalPrice = $this.find('.price__container').text();
        
        if (bssComparePrice !== "" && bssComparePrice !== null &&  bssOriginalPrice !== "" && bssOriginalPrice !== null) {
          let vatComparePrice = calculatePriceWithVAT(bssComparePrice);
          let vatOriginalPrice = calculatePriceWithVAT(bssOriginalPrice);
          if(vatComparePrice && vatOriginalPrice){
            $this.find('.tz-bss-b2b-vat-price').show();
            $this.find('.tz-bss-incl-vat-compare-price').text(`€${vatComparePrice}`);
            $this.find('.tz-bss-incl-vat-original-price').text(`€${vatOriginalPrice}`);
          }
          $this.find('.price__container').after('<span class="tz-excl-vat-text notranslate" style="display: contents;"> (excl. VAT)</span>');
          $this.find('.notranslate.price').css('margin-top','0');
          // console.table(bssComparePrice,bssOriginalPrice,vatComparePrice,vatOriginalPrice);
          clearInterval(loopIntervalId);
        }
    }, 1000);
  });
  
  
});
